import React, { useState } from 'react';
import '../styles/DoubleClickExample.css';
import '../styles/MouseHoverExample.css';
import '../styles/DragAndDropExample.css';
import '../styles/MouseActionsExample.css';

const MouseActionsExample = () => {
  const [doubleClickMessage, setDoubleClickMessage] = useState('');
  const [showSubmenu, setShowSubmenu] = useState(false);
  const [isDropped, setIsDropped] = useState(false);

  const handleDoubleClick = () => {
    setDoubleClickMessage('Double click successful! You have triggered the double-click action.');
  };

  const handleDragStart = (event) => {
    event.dataTransfer.setData('text/plain', 'drag-source');
    event.dataTransfer.effectAllowed = 'move';
  };

  const handleDragOver = (event) => {
    event.preventDefault();
    event.dataTransfer.dropEffect = 'move';
  };

  const handleDrop = (event) => {
    event.preventDefault();
    setIsDropped(true);
  };

  const dragBox = (
    <div
      id="drag-source"
      className={`drag-and-drop-source ${isDropped ? 'drag-and-drop-source--placed' : ''}`}
      draggable={!isDropped}
      onDragStart={isDropped ? undefined : handleDragStart}
    >
      Drag me
    </div>
  );

  return (
    <div className="mouse-actions-page" id="mouse-actions-page">
      <div className="mouse-actions-row">
        <section className="mouse-actions-section" id="double-click-section">
          <div className="double-click-example mouse-actions-card">
            <h3 className="mouse-actions-section-title">Double Click</h3>
            <p className="double-click-example-description">
              Double-click the button below to trigger the action.
            </p>

            <button
              type="button"
              onDoubleClick={handleDoubleClick}
              className="double-click-button"
              id="double-click-me-button"
            >
              Double Click Me
            </button>

            {doubleClickMessage && (
              <p className="double-click-message" id="double-click-message" role="status">
                {doubleClickMessage}
              </p>
            )}
          </div>
        </section>

        <section className="mouse-actions-section" id="mouse-hover-section">
          <div className="mouse-hover-example mouse-actions-card">
            <h3 className="mouse-actions-section-title">Mouse Hover</h3>
            <p className="mouse-hover-example-description">
              Hover on the elements below to reveal hidden content.
            </p>

            <div className="mouse-hover-section">
              <h4 className="mouse-hover-section-title">Hover Menu</h4>
              <p className="mouse-hover-section-hint">
                Hover on the button to open the submenu.
              </p>

              <div
                className="mouse-hover-menu"
                onMouseEnter={() => setShowSubmenu(true)}
                onMouseLeave={() => setShowSubmenu(false)}
              >
                <button
                  type="button"
                  className="mouse-hover-trigger"
                  id="mouse-hover-trigger"
                >
                  Move on
                </button>

                {showSubmenu && (
                  <ul className="mouse-hover-submenu" id="mouse-hover-submenu">
                    <li id="mouse-hover-submenu-item-1">Profile</li>
                    <li id="mouse-hover-submenu-item-2">Settings</li>
                    <li id="mouse-hover-submenu-item-3">Logout</li>
                  </ul>
                )}
              </div>
            </div>
          </div>
        </section>
      </div>

      <section className="mouse-actions-section" id="drag-and-drop-section">
        <div className="drag-and-drop-example mouse-actions-card">
          <h3 className="mouse-actions-section-title">Drag and Drop</h3>
          <p className="drag-and-drop-description">
            Drag the box into the drop zone.
          </p>

          <div className="drag-and-drop-board">
            <div className="drag-and-drop-source-wrap">
              <p className="drag-and-drop-label">Drag source</p>
              {isDropped ? (
                <div className="drag-and-drop-source-empty" id="drag-source-area">
                  Empty
                </div>
              ) : (
                dragBox
              )}
            </div>

            <div className="drag-and-drop-target-wrap">
              <p className="drag-and-drop-label">Drop target</p>
              <div
                id="drop-target"
                className={`drag-and-drop-target ${isDropped ? 'drag-and-drop-target--filled' : ''}`}
                onDragOver={handleDragOver}
                onDrop={handleDrop}
              >
                {isDropped ? dragBox : 'Drop here'}
              </div>
            </div>
          </div>

          {isDropped && (
            <p className="drag-and-drop-message" id="drag-drop-message" role="status">
              Drag and drop successful! The box was moved to the drop zone.
            </p>
          )}
        </div>
      </section>
    </div>
  );
};

export default MouseActionsExample;
